import { Link } from 'react-router-dom';

const ServicesTeaser = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5">
            <div className="bg-zinc-900 text-white rounded-2xl p-10 h-full flex flex-col relative overflow-hidden">
              <div className="absolute top-6 right-6 bg-yellow-500 text-black px-4 py-2 rounded-full text-xs font-bold">
                MOST POPULAR
              </div>

              <div className="w-20 h-20 flex items-center justify-center mb-6">
                <i className="ri-truck-line text-yellow-500 text-6xl"></i>
              </div>

              <h3 className="text-3xl font-bold mb-4">Concrete Pumping</h3>

              <p className="text-gray-300 text-base leading-relaxed mb-6 flex-grow">
                Efficient pouring for foundations, slabs, walls, pools, driveways, and more using advanced equipment. Our state-of-the-art concrete pumps ensure precision and speed for projects of all sizes.
              </p>

              <Link
                to="/services"
                className="bg-yellow-500 text-black px-6 py-4 rounded-lg font-bold text-center hover:bg-yellow-400 transition-all flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
              >
                LEARN MORE
                <i className="ri-arrow-right-line"></i>
              </Link>

              <div className="absolute bottom-0 right-0 w-64 h-64 opacity-5">
                <img
                  src="https://public.readdy.ai/ai/img_res/ea9e31d3346cf08ddd08cd875388ed84.jpg"
                  alt=""
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col gap-6">
            <div className="bg-gray-50 rounded-2xl p-10 flex-1 relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <img
                  src="https://readdy.ai/api/search-image?query=natural%20stone%20texture%20pattern%20gray%20granite%20rock%20surface%20simple%20clean%20background&width=800&height=400&seq=stone-texture&orientation=landscape"
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="relative">
                <div className="w-16 h-16 flex items-center justify-center mb-4">
                  <i className="ri-stack-line text-black text-5xl"></i>
                </div>

                <h3 className="text-2xl font-bold text-black mb-3">Stone Services</h3>

                <p className="text-gray-700 text-base leading-relaxed mb-6">
                  Installation of stone for landscaping, retaining walls, patios, and decorative elements. Transform your property with beautiful, durable stonework.
                </p>

                <Link
                  to="/services"
                  className="text-yellow-500 font-bold text-base hover:text-yellow-600 transition-colors inline-flex items-center gap-2 cursor-pointer whitespace-nowrap"
                >
                  LEARN MORE
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-10 shadow-lg flex-1">
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className="ri-tools-line text-black text-5xl"></i>
              </div>

              <h3 className="text-2xl font-bold text-black mb-4">Additional Services</h3>

              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-gray-700 text-sm">
                  <i className="ri-checkbox-circle-fill text-yellow-500 text-xl mt-0.5"></i>
                  <span>Block filling for structural integrity</span>
                </li>
                <li className="flex items-start gap-3 text-gray-700 text-sm">
                  <i className="ri-checkbox-circle-fill text-yellow-500 text-xl mt-0.5"></i>
                  <span>Grading partnerships for site preparation</span>
                </li>
                <li className="flex items-start gap-3 text-gray-700 text-sm">
                  <i className="ri-checkbox-circle-fill text-yellow-500 text-xl mt-0.5"></i>
                  <span>Custom masonry work tailored to your needs</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesTeaser;